"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLayout = void 0;

var _LayoutConstants = require("./LayoutConstants");

var layoutValues = Object.values(_LayoutConstants.LAYOUT).sort(function (a, b) {
  return a - b;
});

var getLayout = function getLayout(windowWidth) {
  return windowWidth;
};

exports.getLayout = getLayout;